import React from 'react';
import ReactToggle from 'react-toggle';

class TopBarPanel extends React.Component {
  constructor(props) {
    super(props);

    let topbarData = {
      topbar: false,
      filter: false,
      sorting: false,
      viewchanger: false,
      topbarpagination: false,
    };

    if ('topbarData' in this.props) {
      topbarData = this.props.topbarData ? this.props.topbarData : topbarData;
    }

    this.state = {
      topbarData,
    };
  }
  handleAttributeOnOff(element) {
    const elmData = this.state.topbarData;
    if (elmData[element] === 'false' || elmData[element] === false) {
      elmData[element] = true;
    } else {
      elmData[element] = false;
    }
    this.props.onTopBarSubmit(elmData);
  }
  render() {
    const { topbarData } = this.state;

    return (<div role="tabpanel" className="tab-pane" id="topbar">

      <div className="flex-row">
        <div className="flex-md-4 flex-xs-9">
          <p className="caption">{API.LANG.SHOW_OR_HIDE_THE_TOPBAR}</p>
        </div>
        <div className="flex-md-1 flex-xs-3 end-xs">
            <ReactToggle
              defaultChecked={topbarData.topbar === 'true'}
              onChange={this.handleAttributeOnOff.bind(this, 'topbar')}
            />
        </div>
      </div>

      <div className="flex-row">
        <div className="flex-md-4 flex-xs-9">
          <p className="caption">{API.LANG.SHOW_OR_HIDE_THE_SEARCH_FILTER_ATTRIBUTES}</p>
        </div>
        <div className="flex-md-1 flex-xs-3 end-xs">
            <ReactToggle
              defaultChecked={topbarData.filter === 'true'}
              onChange={this.handleAttributeOnOff.bind(this, 'filter')}
            />
        </div>
      </div>

      <div className="flex-row">
        <div className="flex-md-4 flex-xs-9">
          <p className="caption">{API.LANG.SHOW_OR_HIDE_THE_SORTING_OPTION}</p>
        </div>
        <div className="flex-md-1 flex-xs-3 end-xs">
            <ReactToggle
              defaultChecked={topbarData.sorting === 'true'}
              onChange={this.handleAttributeOnOff.bind(this, 'sorting')}
            />
        </div>
      </div>

      <div className="flex-row">
        <div className="flex-md-4 flex-xs-9">
          <p className="caption">{API.LANG.SHOW_OR_HIDE_THE_VIEW_CHANGER}</p>
        </div>
        <div className="flex-md-1 flex-xs-3 end-xs">
            <ReactToggle
              defaultChecked={topbarData.viewchanger === 'true'}
              onChange={this.handleAttributeOnOff.bind(this, 'viewchanger')}
            />
        </div>
      </div>

      <div className="flex-row">
        <div className="flex-md-4 flex-xs-9">
          <p className="caption">{API.LANG.SHOW_OR_HIDE_THE_TOPBAR_PAGINATION}</p>
        </div>
        <div className="flex-md-1 flex-xs-3 end-xs">
            <ReactToggle
              defaultChecked={topbarData.topbarpagination === 'true'}
              onChange={this.handleAttributeOnOff.bind(this, 'topbarpagination')}
            />
        </div>
      </div>

      </div>
    );
  }
}

export default TopBarPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/topbarPanel.js
 **/